import { createContext, useContext, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import logo from '../assets/logo.svg';
import { SplashLoader } from '../components/SplashLoader';
import { ApiError, api } from '../lib/api';
import { useAdminMe } from '../lib/auth';
import { AddCreatorModal } from '../pages/admin/AddCreatorModal';
import { SetPasswordModal } from '../pages/admin/SetPasswordModal';
import styles from './AdminLayout.module.css';

interface AdminCtx {
  openAddCreator: () => void;
  closeAddCreator: () => void;
  addCreatorOpen: boolean;
}

const Ctx = createContext<AdminCtx | null>(null);

export function useAdmin(): AdminCtx {
  const v = useContext(Ctx);
  if (!v) throw new Error('useAdmin outside AdminLayout');
  return v;
}

async function logout() {
  try {
    await api.post('/api/admin/logout');
  } catch {
    /* ignore */
  }
  window.location.assign('/admin/login');
}

export function AdminLayout() {
  const me = useAdminMe();
  const [addCreatorOpen, setAddCreatorOpen] = useState(false);
  const [pwOpen, setPwOpen] = useState(false);

  if (me.isPending) return <SplashLoader />;
  if (me.isError) {
    if (me.error instanceof ApiError && me.error.status === 401) {
      return <Navigate to="/admin/login" replace />;
    }
    return <SplashLoader />;
  }

  return (
    <Ctx.Provider
      value={{
        addCreatorOpen,
        openAddCreator: () => setAddCreatorOpen(true),
        closeAddCreator: () => setAddCreatorOpen(false),
      }}
    >
      <div className={styles.shell}>
        <header className={styles.header}>
          <div className={styles.headerLeft}>
            <img src={logo} alt="Kick" className={styles.logo} />
            {/* <h1 className={styles.title}>Creator List</h1> */}
          </div>
          <div className={styles.headerRight}>
            <button
              type="button"
              className={styles.btnAdd}
              id="add-creator-btn"
              onClick={() => setAddCreatorOpen(true)}
            >
              + Add Creator
            </button>
            <button type="button" className={styles.btnLogout} onClick={() => setPwOpen(true)}>
              Password
            </button>
            <button type="button" className={styles.btnLogout} onClick={logout}>
              Sign Out
            </button>
          </div>
        </header>
        <div className={styles.main}>
          <Outlet />
        </div>
        <SetPasswordModal open={pwOpen} onClose={() => setPwOpen(false)} />
        <AddCreatorModal open={addCreatorOpen} onClose={() => setAddCreatorOpen(false)} />
      </div>
    </Ctx.Provider>
  );
}
